export default __webpack_public_path__ + "static/media/image5.08fe488d.png";